export class ColorLabelProviderCommon {

  public static COLOR = '#999999';
  public static LABEL = '';

}
